
<error-error-content 
  image="assets/img/images/error-images/image4.png"
  errorType="INTERNAL_SERVER_ERROR"
  copy="ERROR_500"></error-error-content>
